import axios from "axios";

const actions = {
  getS3StructureUrl(context) {
    return axios
      .get("document/url")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getPresignedDownloadUrl(context, path) {
    return axios
      .get("document/downloadurl?path=" + path)
      .then(function (response) {
        return response.data.url;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getPresignedPublicUrl(context, item) {
    return axios
      .get("document/publicUrl?path=" + item.path + `&id=${item.id}`)
      .then(function (response) {
        return response.data.url;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getPresignedPdf(context, payload) {
    let pathStr = "";
    let locationId = "";
    let isInline = "";

    if (typeof payload === "string") {
      pathStr = payload;
    } else if (payload && typeof payload === "object") {
      pathStr = payload.path;
      isInline = payload.inline;
      locationId = payload.locationId;
    }

    return axios
      .get(
        "document/urlpdf?inline=true" +
          "&path=" +
          pathStr +
          "&locationId=" +
          locationId,
      )
      .then(function (response) {
        return response.data.url;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;
